import PropTypes from 'prop-types';
import Platform from "react-native-web/dist/exports/Platform";
import getPropSelector from './getPropSelector';
const contentfulPropsTypes = {
  ...Platform.select({
    web: {
      'data-contentful-field-id': PropTypes.string,
      'data-contentful-entry-id': PropTypes.string
    },
    default: {}
  })
};
export default {
  /**
   * Set of contentful properties used for the content preview inspector.
   */
  types: contentfulPropsTypes,
  /**
   * Filters a props object, returning only contentful props.
   */
  select: getPropSelector(contentfulPropsTypes)
};